import React from 'react';
import C18SubMenuHeader00 from './C18SubMenuHeader00'
import C18Button00 from './C18Button00'
import C18Select01 from './C18Select01'
import history from '../../history'
import {cl,getTime,globs,getRandomString,constant,delay,
} from '../../components/utils/utils';
import {dbVals,sendArray} from '../../components/utils/http';
import {pInd}from'../../components/utils/paramIds'
import {wsTrans,saveSession,getParamId2,} from '../utils/utils'
import {privs,makeSettingsInfo,newAccount} from './C18utils'

class C18RecordAi extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      showPane:true,
      pageType:"chat",
      vectStMax:".1K",
      vectStId:"zones00",

      messages:[
      ],
      systems:{},
    }
    this.chatDiv=React.createRef();
  }

  componentDidMount(){
//     this.initAudio()
    this.loadInfo()
    cl("Mount")
    document.addEventListener("keyup",this.keyPress)
//     document.addEventListener("keyPress",this.keyPress)
//     window.addEventListener('beforeunload', this.saveSearch);
//     this.graph = this.makeGraph(this.svgDiv.current)
  }

  componentWillUnmount=()=>{
    cl("component will unmount")
    if(this.mediaRecorder){this.mediaRecorder.stop()}
    clearInterval(this.getLevelInterval)
  }

  keyPress=(e)=>{
//     cl(e.code)
    if(e.code=="Space"){this.recordAiIcon()}
  }

  loadInfo=async()=>{
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/aiInfo",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body:{type:"systemPrompt"}
    })
//     cl(res.data)
    let systems=res.data
    let sesh=globs.userData.session
//     cl(sesh)
    this.site=sesh.siteId
    this.zone=sesh.zoneId
//     cl(globs.zonesInfo.info)
//     cl(this.zone)
    let zone=globs.zonesInfo.info.filter(z=>{
      return z.zoneId==this.zone
    })[0]
//     cl(zone)
    if(zone){
      this.zoneIndex=zone.siteZoneIndex
      this.gwType=zone.gatewayType
      cl(this.site,this.zone,this.zoneIndex,this.gwType)
    }
//     let systemId=Object.keys(systems)[0]||""
    let systemId=1
    let vectSt=await this.loadVectSt()
//     cl(vectSt)
//     cl(Object.keys(vectSt))
//     let vectStId=vectSt[0]
    this.setState({systems:systems,systemId:systemId,vectSt:vectSt,
      /*vectStId:vectStId,*/vectStMax:"0.4K"
    })
//     cl("send system")
//     await this.sendSystem(0)
//     cl("send vect store")
//     this.sendVectSt()
  }

  blobToBase64=(blob)=>{
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  appendChat=(src,msg)=>{
//     let chat2=chatRef.current.slice(0)
//     chat2.push({
//       src:src,
//       msg:msg,
//     })
//     setChat(chat2)
  }

  sendAudio=async(data)=>{
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {cmd:"transcribe",data:data}})
    this.sendText(res.data.transcription)
  }

  stopRecord=()=>{
    this.mediaRecorder.stop()
    this.audioStream.getTracks().forEach(t=>{t.stop()})
  }

  getLevel=()=>{
    var audioStreamSource=
      this.audioContext.createMediaStreamSource(this.audioStream);
    audioStreamSource.connect(this.analyser);
    this.analyser.getByteTimeDomainData(this.domainData)
    let total=0
    let avg=0
    this.domainData.forEach(d=>{
      avg=avg*.95+(d-128)*.05// 351hz filter
      total+=avg*avg
    })
    this.levelAvg=0.9*this.levelAvg+0.1*Math.sqrt(total)
    cl(this.levelAvg)
//     cl((getTime()-this.startTime))
    if(((getTime()-this.startTime)>5)&&(this.levelAvg<100)){
//       cl("stop")
      this.stopRecord()
      clearInterval(this.getLevelInterval)
    }
  }

  addChunk=async(chunk)=>{
    cl("send Chunk")
//     cl(levelAvg)
//     cl(g)
//     cl(speakingRef.current)
//     let st=this.state
    let data=await this.blobToBase64(chunk.data)
    this.sendAudio(data)
//     cl(arr.length)
//     let res=await this.sendAudio({
//       uri:"/o/sendAudio",
//       clipName:this.clipName,
//       done:st.speaking,
//       content:arr,
//     })
//     cl(res)
//     this.appendChat("assistant",res.content)
  }

  initAudio=async()=>{
    this.audioStream=await navigator.mediaDevices.getUserMedia({
      audio:true,
      video:false
    })
    this.mediaRecorder=new MediaRecorder(this.audioStream)
    this.mediaRecorder.addEventListener("dataavailable",this.addChunk)
    this.audioContext = new AudioContext();
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 1024;
    this.analyser.minDecibels = -35;
    this.mediaRecorder.start()
    this.domainData=new Uint8Array(1024)// 1024 default
    this.startTime=getTime()
    this.levelAvg=200
    this.getLevelInterval=setInterval(this.getLevel,100)
    cl("init audio done")
  }

  appendMessages=(role,text)=>{
    let st=this.state
    let messages=st.messages.slice(0)
    messages.push({type:role,text:text})
    this.setState({messages:messages})
  }

  openAccount=async(accountId)=>{
    cl(`open account ${accountId}`)
//     this.setState(vals)
//     cl(vals)
    globs.userData.session.accountId=accountId
    saveSession(globs.userData.session)
    let endPoint=(
      (!privs("super","",constant.AREA_PRIVS_READ))&&
      globs.privsInfo.thirdPartyAccounts?.length)?
      "/tp/tpSession":"/su/suSession"
    let res=await wsTrans("usa", {cmd: "cRest", uri: endPoint, method: "update",
      sessionId: globs.userData.session.sessionId,
      body: {accountId}})
//     cl(res)
//     cl("***********************reload")
//     setTimeout(()=>{window.location.reload()},1000)
    history.push("/usa/Blank")
    newAccount()
//     await window.location.reload()
    await delay(1000)
  }

  openZone=async(ai)=>{
    cl(ai)
//     return
//     cl(this.state)
    cl(globs.userData.session)
    if(ai.account!=globs.userData.session.accountId){
      await this.openAccount(ai.account)
    }
    let url="/usa/c18/sites"
    if(ai.site){
//       globs.userData.session.siteId=ai.site
      url+=`/${ai.site}`
    }
    if(ai.zone){
      url+=`/zones/${ai.zone}`
    }
    cl(url)
    globs.userData.session.zoneId=ai.zone
    history.push(url);
// https://localhost.link4cloud.com:3104/usa/c18/sites/urWXE8aqwww8SpeY/zones/uj8CYuHyBQCdW0uU
// https://localhost.link4cloud.com:3104/usa/c18/sites/urWXE8aqwww8SpeY/zones/Hk_Lt2EbUmAsdJv2
//     if()
// ProcUrl: /usa/c18/sites/1gZ3nNCFCA0AUxcJ/zones/PCTY0Y9C5f4usbPr
//     history.push(`/usa/c18/sites/${ai.site}/zones/${ai.zone}`)}
  }

  gotText=(aiResp)=>{
    this.appendMessages("assistant",aiResp.text)
  }

  getSettingsInfo=()=>{
    if(this.settingsInfo){return}
    let props={parms:{
      site:this.site,
      zone:this.zone,
    }}
    cl(props)
    this.settingsInfo=makeSettingsInfo(props)
    cl(this.settingsInfo)
  }

  findPage=(page)=>{

  }

  openSettingsUsa=(setting)=>{
// ProcUrl: /usa/c18/sites/urWXE8aqwww8SpeY/zones/Hk_Lt2EbUmAsdJv2/admin/selectSensors
// /usa/c18/sites/urWXE8aqwww8SpeY/zones/Hk_Lt2EbUmAsdJv2selectSensors
// /usa/c18/sites/urWXE8aqwww8SpeY/zones/6dvE25yoba_k2Qy3/admin/selectSensors
    cl(setting)
    let url=`/usa/c18/sites/${this.site}/zones/${this.zone}/${setting.url.substring(9)}`
    cl(url)
    history.push(url)
  }

  openSettingsFui=(setting,zone)=>{
// /usa/c18/fui/setpoints/0-0-240-0-
    cl(zone)
    cl(setting)
    let z=zone.siteZoneIndex
    let u=0
    let c=240
    let i=0
    let url=`/usa/c18${setting.url}/${z}-${u}-${c}-${i}`
    cl(url)
    history.push(url)
  }

  openSettingsType=(setting,zone)=>{
    switch(setting.mode){
      case "usa":
        return this.openSettingsUsa(setting,zone)
      case "fui":
        return this.openSettingsFui(setting,zone)
      default:
        break
    }
  }

  openSettingsPage=(page, zone)=>{
    if(!zone){return}
    let gwType=zone.gatewayType.toString()
    cl(zone)
    let found={}
    let keys0=Object.keys(this.settingsInfo)
    cl(keys0)
    keys0.forEach(k=>{
      let arr=this.settingsInfo[k]
      arr.forEach(a=>{
        if(a.name==page){
          found[k]=a
//           found.push({key:k,v:a})
        }
      })
    })
    let keys=Object.keys(found)
      .filter(k=>{return k.indexOf(gwType)>0})
    cl(keys)
    let key=(keys[0])?keys[0]:keys0[0]
    cl(key)
    let setting=this.settingsInfo[key]
      .filter(s=>{return s.name==page})[0]
    cl(setting)
    this.openSettingsType(setting,zone)

  }

  openPage=(aiResp)=>{
    this.getSettingsInfo()
//     cl(globs.userData.session.zoneId)
//     cl(globs.zonesInfo.info)
    let zone=globs.zonesInfo.info.filter(z=>{
      return z.zoneId==globs.userData.session.zoneId
    })[0]
    cl(zone)
    this.openSettingsPage(aiResp.page,zone)


//     cl(found)
//     cl(globs)
//     cl(aiResp)
    let page=this.findPage(aiResp.page)
  }

  sendText=async(txt)=>{
//     cl(txt)
    let st=this.state
    this.appendMessages("user",txt)
    let max=Math.round(+st.vectStMax.slice(0,-1)*1024)
    let query={
        cmd:"sendText",
        text:txt,
        vectSt:st.vectStId,
        sendMax:max,
        systemId:st.systems[st.systemId].id
      }
//       cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "create", sessionId: globs.userData.session.sessionId,
      body: query})
    let aiResp=res.data.aiResponse
    cl(aiResp)
    let cmds={
      openZone:this.openZone,
      openPage:this.openPage,
      text:this.gotText,
      changeSetpoint:this.changeSetpoint,
    }
    if(cmds[aiResp.cmd]){cmds[aiResp.cmd](aiResp)}else{
      cl(`unknown cmd: ${aiResp.cmd}`)
    }
//     switch(aiResp.cmd){
//       case "openZone":
//         return this.openZone(aiResp)
//       case "text":
//         this.appendMessages("assistant",aiResp.text)
//         break
//     }
//     if(aiResp.tools){
//       let func0=aiResp.tools[0].function
//       let func=func0.name
//       let args=JSON.parse(func0.arguments)
//   //     cl(func)
//   //     cl(args)
//       if(this.aiTools[func]){this.aiTools[func](args)}
//     }
//     if(aiResp.text){
//       this.appendMessages("assistant",aiResp.text)
//     }
  }

  loadVectSt=async()=>{
    cl("load vect")
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {cmd:"getVectSt"}})
    cl(res)
    let vectSt=res.data.vectSt
    this.setState({vectSt:vectSt})
    cl(res)
    cl(res.data.vectSt)
    return vectSt
  }

  loadContext=async()=>{
    cl("load context")
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {cmd:"getContext"}})
    cl(res)
    let context=res.data?.context
//     (res.data?.context).split("\n").join("<br/>")
    this.setState({context:context})
  }

  sendVectSt=async()=>{
//     cl("save sendVectSt")
    let st=this.state
//     cl(st)
//     cl(st.vectStMax)
//     cl(st.vectStMax.slice(0,-1))
    let max=Math.round(+st.vectStMax.slice(0,-1)*1024)
    cl(st.vectSt)
    cl(st.vectStId)
    let query={cmd:"sendVectSt",vectSt:st.vectStId,
      maxSend:max,
    }
    cl(query)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
//     let st=this.state
//     let sys=st.systems[st.systemId]
//     return await wsTrans("usa", {cmd: "cRest", uri: "/s/aiInfo",
//       method: "update", sessionId: globs.userData.session.sessionId,
//       body: Object.assign({type:"systemPrompt",id:st.systemId,},sys)
//     })
  }

  sendMsgOpenAi=async(query)=>{
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/openai",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  sendSystem=async(systemIndex)=>{
    let st=this.state
    let systemId=st.systems[systemIndex].id
    let query={cmd:"sendSystem",systemId:systemId}
    cl("query")
    await this.sendMsgOpenAi(query)
    cl("done")
  }

/********************* Setpoints ***************************/

// var getParamId=(table)=>{
// // returns pid, type, mult
// //   cl(pa.pi[1800][table][column])
// //   let ofs=pa.pi[1900][table][column]
//   let tabInfo=pa.pInd[1900][table]
// //   cl(tabInfo)
//   return {
//     base:tabInfo[0],
//     pids:pa.pi[1900][table],
//     mult:tabInfo[2],
//   }
// }
//
// var getSiteAndZone=()=>{
//   cl([g.account,g.site,g.zone])
// }
//
  spGetNames=()=>{
    let nameId=getParamId2(this.gwType,"configuration_setpoints","name")
    cl(this.gwType)
    if(!this.gwType){return[]}
    let mult=pInd[this.gwType].config_setpoints[2]
    let names=[]
    for(let i=0;i<8;i++){
      let pid=nameId+mult*i
      cl(pid)
      cl(this.zoneIndex)
      names.push(dbVals.z[this.zoneIndex][255][pid].toString().toLowerCase())
    }
    return names
  }

  cnvNum=(val)=>{
    if(!isNaN(val)){val=+val}
    return val
  }

  sendValue=async(pid,val)=>{
    cl(dbVals.z[this.zoneIndex][255][pid])
    let arr=[{
      z:this.zoneIndex,
      c:255,
      i:pid,
      d:val,
      f:1,
      t:getTime(),
    }]
    cl(arr)
    return await sendArray(arr,false,this.gwType,0,false)
  }

  changeSetpoint=async(args)=>{
  //   let pidInfo=getParamId("config_setpoints")

    let ids={
      "enable":"enabled",
      "setpoint name":"name",
      "start time":"startTimeOfDay",
      "heat setpoint":"heatSetpoint",
      "cool setpoint":"coolSetpoint",
      "hum setpoint":"humidifySetpoint",
      "dehum setpoint":"dehumidifySetpoint",
      "ramp time":"rampMinutes",
      "astro adjust":"astroAdjust",
    }
    let spId=this.spGetNames().indexOf(args.setpointName.toLowerCase())
    cl(spId)
    let colId=ids[args.columnName]
    cl(colId)
    let colPid=getParamId2(this.gwType,"configuration_setpoints",colId)
    let mult=pInd[this.gwType].config_setpoints[2]
    let pid=colPid+spId*mult
    let val=this.cnvNum(dbVals.z[this.zoneIndex][255][pid])
    cl(val)
    cl(args.value)
    let newVal=this.cnvNum(args.value)
    if(colId=="startTimeOfDay"){
      if(newVal>100){newVal/=100}
      let parts=newVal.toString().split(" ")
      if(parts[1]){newVal=parts[0]+parts[1]/100}
      let newValInt=Math.floor(+newVal)
      let newValFrc=+newVal-newValInt
      switch(args.unit.toLowerCase()){
        case "hours":
          newVal*=60
          break
        case "a.m.":
        case "am":
          newVal=60*newValInt+newValFrc*100
          break
        case "p.m.":
        case "pm":
          newVal=60*(newValInt+12)+newValFrc*100
          break
        default:
          newVal=60*newValInt+newValFrc*100
          break
      }
      newVal=Math.round(newVal)
    }
    cl(newVal)
    if(colId=="astroAdjust"){
      newVal=["none","sunrise","sunset"].indexOf(args.value.toLowerCase())
      if(newVal<0){newVal=0}
    }
    cl(newVal)
    switch(args.command){
      case "change":
        val=newVal
        break
      case "increase":
        val+=newVal
        break
      case "decrease":
        val-=newVal
        break
      default:
        val=newVal
    }
    cl(val)
    let res=await this.sendValue(pid,val)
    globs.events.publish("newContext")
    cl(res)
//     cl(pidInfo)
//     return {cmd:"changeSetpoint",
//       setpointName:args.setpointName,
//       columnName:args.columnName,
//       command:args.command,
//       value:args.value,
//       unit:args.unit,
//     }
  }

/********************* End Setpoints ***************************/

  onChange=(type,vals)=>{
//     cl(type,vals)
    let st=this.state
    let cmds={newSystem:this.newSystem,setSystemName:this.setSystemName,
      saveSystem:this.saveSystem,recordAiIcon:this.recordAiIcon,
      sendVectSt:this.sendVectSt
    }
    if(cmds[type]){return cmds[type](vals)}
//     cl("still")
//     cl(type)
//     cl(cmds[type])
    switch(type){
      case "divClick":
        this.setState({showPane:!st.showPane})
        cl("click")
        break
      case "keyPress":
        if(vals.e.key=="Enter"){this.sendText(st.inpText)}
//         cl(vals)
//         cl(vals.e.key)
        break
      case "setState":
        this.setState(vals)
        break
    }
  }

  newSystem=()=>{
    let st=this.state
    let systems=Object.assign({},st.systems)
    let id=getRandomString(8)
    systems[id]={
      name:"New Prompt",
      text:"",
    }
    this.setState({systems:systems,systemId:id})
    this.sendSystem()
  }

  setSystemName=(vals)=>{// text, too
    let st=this.state
//     cl(vals)
    let systems=Object.assign({},st.systems)
    Object.assign(systems[st.systemId],vals)
    this.setState({systems:systems})
  }

  saveSystem=async()=>{
    cl("save system")
    let st=this.state
    let sys=st.systems[st.systemId]
    return await wsTrans("usa", {cmd: "cRest", uri: "/s/aiInfo",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: Object.assign({type:"systemPrompt",id:st.systemId,},sys)
    })
  }

  recordAiIcon=()=>{
    cl("record")
    this.initAudio()
  }

  showMessages=()=>{
    let st=this.state
    var bgColors={
      assistant:"#C0E0FF",
      user:"white",
      system:"FFFFC0",
    }
    return st.messages.map((m,i)=>{
      return(
        <span key={i} style={{backgroundColor:bgColors[m.type]}}>
        {m.text}<br/>
        </span>
      )
    })
  }

  showChat=()=>{
    let st=this.state
    setTimeout(e=>{
      this.chatDiv.current.scrollTo(
      0, this.chatDiv.current.scrollHeight,100);
    })
    let path=`${constant.expressUrl}/usa/images/icons/record.png`
    return(
      <>
      <div ref={this.chatDiv} style={{position:"relative",whiteSpace:"wrap",height:400,
        overflowY:"auto",
      }}
      onClick={e=>{this.onChange("divClick")}}
      >
      {this.showMessages()}
    </div>
    <div>
    <table><tbody>
    <tr><td>
      <input type="text" style={{width:"100%"}}
      value={st.inpText||""}
      onKeyPress={e=>{this.onChange("keyPress",{e:e})}}
      onChange={e=>{this.onChange("setState",{inpText:e.target.value})}}
      />
    </td><td style={{width:32,paddingRight:0}}>
        <img style={{width:32,height:32,paddingRight:0}} src={path}
        onClick={e=>{this.onChange("recordAiIcon")}}
        />
    </td></tr>
    </tbody></table>
    </div>
      </>
    )
  }

  showSystem=()=>{
    let st=this.state
    let opts=Object.keys(st.systems).map(k=>{
      return{v:k,t:st.systems[k].name}
    })
//     cl(st.systems[st.systemId])
//     cl(st.systems)
//     cl(st.systemId)
    return(
      <div>
      <textarea style={{width:480,height:500}}
      value={st.systems[st.systemId]?.text||""}
      onChange={e=>this.onChange("setSystemName",{text:e.target.value})}

      />
    <div style={{height:10}}/>
    <table><tbody>
    <tr><td>
        <C18Select01 style={{display:"inline-block",marginBottom:0}}
        parms={{
          label:"Select",
          valueName:"systemId",
          systemId:(st.systemId||""),
          opts:opts,
          onChange:(e,v)=>{
            this.onChange("setState",v)
            cl(v)
            this.sendSystem(v.systemId)
          }//this.onChange,
        }}/>
        </td><td>
    <label>Name</label>

      <input type="text" style={{display:"inline-block",width:150,
        marginBottom:16,}}
        value={st.systems[st.systemId]?.name||""}
        onChange={e=>this.onChange("setSystemName",{name:e.target.value})}
      />&nbsp;
      </td><td>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("saveSystem")}}
        >Save</C18Button00>&nbsp;
      </td><td>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("newSystem")}}
        >New</C18Button00>
        </td></tr>
    </tbody></table>

      </div>
    )
  }

  showVectSt=()=>{
    let st=this.state
    let opts=st.vectSt.map(v=>{
      return{v:v,t:v}
    })
    cl(st.vectStMax)
    let amts=["0.1K","0.15K","0.2K","0.25K","0.3K","0.4K","0.55K",
    "0.75K","1K","1.5K","2K","2.5K","3K","4K","5.5K","7.5K","10K"]
    let optsMax=amts.map(a=>{return {v:a,t:a}})
    return(
      <div>
    <table style={{width:"initial"}}><tbody>
    <tr><td>
        <C18Select01 style={{display:"inline-block",marginBottom:0}}
        parms={{
          label:"Select",
          valueName:"vectStId",
          vectStId:(st.vectStId||""),
          opts:opts,
          onChange:(e,v)=>{this.onChange("setState",v)}//this.onChange,
        }}/>
        </td><td>
        <C18Select01 style={{display:"inline-block",marginBottom:0}}
        parms={{
          label:"Max Send",
          valueName:"vectStMax",
          vectStMax:(st.vectStMax||""),
          opts:optsMax,
          onChange:(e,v)=>{this.onChange("setState",v)}//this.onChange,
        }}/>
        </td><td>
        <C18Button00 type="button" className="filled"
          onClick={e=>{this.onChange("sendVectSt")}}
        >Save</C18Button00>&nbsp;
      </td></tr>
    </tbody></table>
      </div>
    )
  }

  showContext=()=>{
    let st=this.state
    return(
      <div style={{whiteSpace:"pre-wrap"}}>
      {st.context}
      </div>
    )

  }

  showPage=()=>{
    let st=this.state
    switch(st.pageType){
      case "chat": return this.showChat()
      case "system": return this.showSystem()
      case "vectSt": return this.showVectSt()
      case "context": return this.showContext()
      default:
        return null
    }
  }

  render(){
    let st=this.state
    if(st.showPane){
    return(
      <>
        <C18SubMenuHeader00 parms={{
          items:[
            {v:"chat",t:"Chat"},
            {v:"system",t:"System"},
            {v:"context",t:"Context"},
            {v:"vectSt",t:"Vector St"},
          ],
          pageType: this.state.pageType,
          onChange: o=>{
            cl(o)
            if(o.pageType=="context"){this.loadContext()}
            this.onChange("setState",o)
          },
        }}/>
        <div className="clearfloat"/>
        {this.showPage()}
      </>

    )
  }else{
    return null
  }
    }
}

export default C18RecordAi;
